import React from "react";

const Loader = () => {
  return (
    <div className="loading__page d-flex flex-column justify-content-center">
      <div className="d-flex flex-row justify-content-center align-items-center">
        <div className="loader">
            <svg viewBox="0 0 80 80">
                <circle id="test" cx="40" cy="40" r="32"></circle>
            </svg>
        </div>
      </div>
    </div>
  );
};

export default Loader;